export default __webpack_public_path__ + "static/fs-icon-192x192-097b0fe577963e1c9f520145bf5fe382.png";